
const initState = [];

const NoteTypeDDReducer = (state = initState, action) => {
    switch(action.type) {
        case  'NoteTypeDD' : return  action.payload;
        default: return state;
    }
}
export default NoteTypeDDReducer;